(() => {
  const mobileQuery = window.matchMedia('(max-width: 768px)');

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
  };

  const copyText = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return;
    }
    fallbackCopy(text);
  };

  const setAccordionState = (footer) => {
    footer.querySelectorAll('[data-lm-accordion-button]').forEach((button) => {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      if (mobileQuery.matches) {
        const isOpen = button.getAttribute('aria-expanded') === 'true';
        panel.hidden = !isOpen;
      } else {
        button.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });
  };

  const initFooter = (footer) => {
    if (footer.dataset.lmInitialized === 'true') return;
    footer.dataset.lmInitialized = 'true';

    footer.querySelectorAll('[data-lm-accordion-button]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!mobileQuery.matches) return;
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        if (!panel) return;
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(willOpen));
        panel.hidden = !willOpen;
      });
    });

    setAccordionState(footer);

    const modal = footer.querySelector('[data-lm-modal]');
    if (!modal) return;

    const modalBox = modal.querySelector('[data-lm-modal-box]');
    const closeButton = modal.querySelector('[data-lm-modal-close]');
    const copyButton = modal.querySelector('[data-lm-copy]');
    let previousFocus = null;

    const closeModal = () => {
      modal.classList.remove('is-show');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('lm-footer-modal-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    const openModal = () => {
      previousFocus = document.activeElement;
      modal.classList.add('is-show');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('lm-footer-modal-open');
      window.requestAnimationFrame(() => closeButton?.focus());
    };

    closeButton?.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modalBox?.addEventListener('click', (event) => event.stopPropagation());
    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });

    copyButton?.addEventListener('click', async () => {
      const code = modal.querySelector('[data-lm-code]')?.textContent?.trim();
      if (!code) return;

      try {
        await copyText(code);
        const copiedLabel = copyButton.dataset.copiedLabel || 'Copied!';
        const originalLabel = copyButton.dataset.copyLabel || copyButton.textContent;
        copyButton.textContent = copiedLabel;
        window.setTimeout(() => {
          copyButton.textContent = originalLabel;
        }, 2000);
      } catch (error) {
        console.warn('LumiNova footer: discount code could not be copied.', error);
      }
    });

    if (modal.dataset.openOnLoad === 'true') openModal();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-lm-footer]').forEach(initFooter);
  };

  const handleBreakpointChange = () => {
    document.querySelectorAll('[data-lm-footer]').forEach((footer) => {
      if (mobileQuery.matches) {
        footer.querySelectorAll('[data-lm-accordion-button]').forEach((button) => {
          button.setAttribute('aria-expanded', 'false');
        });
      }
      setAccordionState(footer);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  mobileQuery.addEventListener?.('change', handleBreakpointChange);
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
